import { render } from "./OrderCol.vue?vue&type=template&id=f890fda8&scoped=true"
import script from "./OrderCol.vue?vue&type=script&lang=js"
export * from "./OrderCol.vue?vue&type=script&lang=js"

import "./OrderCol.vue?vue&type=style&index=0&id=f890fda8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f890fda8"]])

export default __exports__